import { Labeled, SelectField, SimpleShowLayout, TextField } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { GenderOptionsId } from "utils/choices";
import { SectionTitle } from "features/SectionTitle";

const SpecialistInfoSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <SimpleShowLayout>
      <SectionTitle
        title="Информация за специализант"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={3}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Име">
            <TextField
              source="userInfo.firstName"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Презиме">
            <TextField
              source="userInfo.secondName"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Фамилия">
            <TextField
              source="userInfo.lastName"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="ЕГН">
            <TextField
              source="userInfo.personId"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Пол">
            <SelectField
              source="userInfo.gender"
              choices={GenderOptionsId}
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Имейл">
            <TextField
              source="userInfo.email"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Външен имейл">
            <TextField
              source="userInfo.externalEmail"
              emptyText="-"
            />
          </Labeled>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default SpecialistInfoSection;
